
import React from 'react'
import { URL_SRV_ARIZTIA } from '../../router/Url'

export const CrudAdminProducto = ({type,data}) => {
    // console.log({type,data})

    return new Promise(async (resolve, reject) => {
        let query = await fetch(URL_SRV_ARIZTIA+'crud_productos',{
            method: 'POST',
            headers: {
                'authorization': "paico2021",
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                type, data
            })
        })
        let responsito = await query.json();
        // console.log(responsito)
        if(responsito){
            resolve(responsito.body)
        }else{
            resolve([])
        }
    })

}
